import CustomModal from "../../Modal/CustomModal";
import CancelStep from "././CancelStep/CancelStep";
import '.././popup.common.css'
import CancelRepearBookingStep from "./CancelRepearBookingStep/CancelRepearBookingStep";
import { useState } from "react";
import { useGlobalContext } from "../../../Context/GlobalContext";

const CancelBookingPopup = ({ onClose, onConfirm, buttonDisabled, nextStep, bookingStatus, bookingDeposit }) => {
	const { bookingDetails, apiError } = useGlobalContext();
	const repeatBooking = bookingDetails?.recurring_group_id !== null && bookingDetails?.recurring_group_id !== undefined && bookingDetails?.recurring_group_id !== '';
	const [showCancelRepearBookingStep, setShowCancelRepearBookingStep] = useState(repeatBooking);

	return (
		<CustomModal
			modalClass={`cancelBookingPopup`}
			show={true}
			onHide={onClose}
		>
			{showCancelRepearBookingStep ? (
				<CancelRepearBookingStep 
				onConfirm={() => {
					setShowCancelRepearBookingStep(false);
				}} 
				onClose={onClose}
				error={apiError}
			/>
			) : (
				<CancelStep 
					onConfirm={onConfirm}
					onClose={onClose}
					status={(bookingStatus || bookingDetails?.status || "")?.toLowerCase()}
					nextStep={nextStep}
					buttonDisabled={buttonDisabled}
					error={apiError}
					bookingStatus={bookingStatus}
					bookingDeposit={bookingDeposit}
				/>
			)}
			
		</CustomModal>
	);
};

export default CancelBookingPopup;
